export const TAB_KEYS = {
  bidding: 'QuoteBiddingLogs',
  collaborators: 'QuoteCollboratorLogs',
  documents: 'DocumentDetails',
  notes: 'NotesDetails',
  productDetails: 'ProductDetails',
  quoteDetails: 'QuoteDetailsForm',
  rate: 'QuoteRate',
  shippingTerms: 'ShippingTermsSearchForm',
  transportationDetails: 'TransportationDetails',
};

export const SECTIONS_BY_FORMS = {
  documentForm: TAB_KEYS.documents,
  notesForm: TAB_KEYS.notes,
  productForm: TAB_KEYS.productDetails,
  quoteDetailsForm: TAB_KEYS.quoteDetails,
  shippingTermsSearchForm: TAB_KEYS.shippingTerms,
  stopsForm: TAB_KEYS.transportationDetails,
};

export const transportationGroupData = [
  {
    id: 'EXPL',
    value: 'Explosives',
  },
  {
    id: 'RACT',
    value: 'Radioactive',
  },
  {
    id: 'STD',
    value: 'Standard',
  },
];

export const transportationModeData = [
  {
    key: 'AIR',
    value: 'AIR',
  },
  {
    key: 'OCN',
    value: 'OCEAN',
  },
  {
    key: 'TRK',
    value: 'TRUCK',
  },
  {
    key: 'TRD',
    value: 'DOMESTIC TRUCKING',
  },
  {
    key: 'RLR',
    value: 'RAILROAD',
  },
  {
    key: 'INA',
    value: 'INTRA AIR',
  },
];
